const REFERRAL_STORAGE_KEY = 'cc_referral_username';

export function captureReferralFromSearch(search) {
  const params = new URLSearchParams(search);
  const ref = params.get('ref');
  if (!ref) {
    return null;
  }

  const normalized = ref.trim().replace(/^@/, '');
  if (!normalized) {
    return null;
  }

  sessionStorage.setItem(REFERRAL_STORAGE_KEY, normalized);
  return normalized;
}

export function getStoredReferralUsername() {
  const value = sessionStorage.getItem(REFERRAL_STORAGE_KEY);
  return value ? value.trim() : null;
}

export function clearStoredReferralUsername() {
  sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
}
